<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      labelWidth="100px"
      label="药品通用名"
      placeholder="请输入药品通用名"
      v-model="drugName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
      prop="drugName"
    />
    <label-input
      label="销售单号"
      placeholder="请输入销售单号"
      v-model="orderId"
      :input-attr="{ maxlength: 50 }"
      type="autocomplete"
      :query-search="queryOrderId"
      clearable
      valueKey="orderId"
      prop="orderId"
    />
    <label-input label="是否凭处方销售" prop="prescriptionStatus">
      <el-select v-model="prescriptionStatus" placeholder="请选择" clearable>
        <el-option
          v-for="item in prescriptionStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input label="处方类型" prop="prescriptionCategory">
      <el-select v-model="prescriptionCategory" placeholder="请选择">
        <el-option
          v-for="item in prescriptionCategoryOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input label="是否补传" prop="patchedStatus">
      <el-select v-model="patchedStatus" placeholder="">
        <el-option
          v-for="item in patchedStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input label="销售时间" prop="dateRange">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :defaultTime="['00:00:00', '23:59:59']"
        valueFormat="yyyy-MM-dd HH:mm:ss"
        align="right"
      ></el-date-picker>
    </label-input>
    <label-input label="校正状态" prop="isCorrection">
      <el-select v-model="isCorrection" placeholder="请选择">
        <el-option
          v-for="item in isCorrectionOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input label="校正类型" prop="correctionTypeCode">
      <el-select v-model="correctionTypeCode" placeholder="请选择">
        <el-option :key="1134" label="全部" :value="null"></el-option>
        <el-option
          v-for="(label, value) in correctionTypeCodeMap"
          :key="value"
          :label="label"
          :value="value"
        ></el-option>
      </el-select>
    </label-input>
  </search-wrapper>
</template>

<script>
import dayjs from 'dayjs';
import Fetch from '@/api';
import searchWrapper from '@/components/global/form/searchWrapper';
import labelInput from '@/components/global/form/labelInputForSupervision';

export default {
  name: 'searchBar',
  props: {
    type: {
      type: String
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    correctionTypeCodeMap: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: Number || undefined
    }
  },
  components: {
    searchWrapper,
    labelInput
  },
  computed: {
    drugName: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugName',
          value: val
        });
      }
    },
    orderId: {
      get() {
        return this.searchParams.orderId;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'orderId',
          value: val
        });
      }
    },
    prescriptionStatus: {
      get() {
        return this.searchParams.prescriptionStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'prescriptionStatus',
          value: val
        });
      }
    },
    prescriptionCategory: {
      get() {
        return this.searchParams.prescriptionCategory;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'prescriptionCategory',
          value: val
        });
      }
    },
    patchedStatus: {
      get() {
        return this.searchParams.patchedStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'patchedStatus',
          value: val
        });
      }
    },
    isCorrection: {
      get() {
        return this.searchParams.isCorrection;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'isCorrection',
          value: val
        });
      }
    },
    correctionTypeCode: {
      get() {
        return this.searchParams.correctionTypeCode;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'correctionTypeCode',
          value: val
        });
      }
    },
    dateRange: {
      get() {
        return this.searchParams.dateRange;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'dateRange',
          value: val
        });
      }
    }, // patchedStatus
    patchedStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '补传', value: '1' },
        { label: '当日上传', value: '0' }
      ];
    },
    prescriptionCategoryOptions() {
      return [
        { label: '全部', value: null },
        { label: '线下处方', value: '1' },
        { label: '电子处方', value: '0' }
      ];
    },
    prescriptionStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '待上传', value: '0' },
        { label: '凭处方销售', value: '1' },
        { label: '未凭处方销售', value: '9' }
      ];
    },
    isCorrectionOptions() {
      return [
        { label: '全部', value: null },
        { label: '已校正', value: true },
        { label: '未校正', value: false }
      ];
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              const yesterday = dayjs().subtract(1, 'days');
              picker.$emit('pick', [
                yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本年',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }
        ]
      };
    }
  },
  methods: {
    search() {
      this.$emit('search');
    },
    queryOrderId(queryString, cb) {
      const { storeId, type } = this;
      Fetch.getSupervisionPrescriptionOrderList({ orderId: queryString, storeId, pageNo: 1, pageSize: 30 }).then(
        ({ data }) => {
          cb(data);
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0 16px;
  align-items: center;
  margin-bottom: 10px;

  .search-btn {
    width: 100px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }
}
</style>
